import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Installation from "@/pages/Installation";
import DeepCleaning from "@/pages/DeepCleaning";
import Repair from "@/pages/Repair";
import GasRefill from "@/pages/GasRefill";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ac-installation-paphos" element={<Installation />} />
          <Route path="/ac-deep-cleaning-paphos" element={<DeepCleaning />} />
          <Route path="/ac-repair-paphos" element={<Repair />} />
          <Route path="/ac-gas-refill-paphos" element={<GasRefill />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
